const firebaseConfig = {
    apiKey: "AIzaSyB_3Y4OX_6VUfKjJt45hdbdERofTwacj88",
    authDomain: "motobot-531ee.firebaseapp.com",
    projectId: "motobot-531ee",
    storageBucket: "motobot-531ee.appspot.com",
    messagingSenderId: "974237139538",
    appId: "1:974237139538:web:9451bfc1c12c97c034158b"
  };

export default firebaseConfig;  